<template>
  <div class="product-box" @click="goDetail">
    <!-- <img class="hf-img" v-if="productObj.storeName === '海富中学'" src="../assets/imgs/hf.png" width="50px"/> -->
    <!-- <div v-for="(blocs, index) in blocsList" :key="index + 'a'">
      <img
        class="hf-img"
        :src="getPhoto(blocs.logo)"
        v-if="(productObj.blocTagBlocId).indexOf(blocs.id) > -1"
        width="50px"
      />
    </div> -->
    <div class="logoSchool">
      <img class="hf-img" v-if="productObj.blocTagBlocId.indexOf(adminid.id) > -1" :src="getPhoto(adminid.logo)" width="50px" />
      <img class="hf-img" v-if="productObj.blocTagBlocId.indexOf(jyy.id) > -1" :src="getPhoto(jyy.logo)" width="50px" />
      <img class="hf-img" v-if="productObj.priFlag" src="../assets/imgs/prim.png" width="50px" />
    </div>
    <div class="top-img">
      <img :src="productObj.pic ? getPhoto(productObj.pic) : '../assets/imgs/book.png'" width="100%" />
    </div>
    <div class="title">{{ productObj.name }}</div>
    <div class="price">
      <span class="new-price">￥{{ productObj.unitPrice }}</span>
      <span class="old-price" v-if="productObj.unitPriceShow">￥{{ productObj.unitPriceShow }}</span>
    </div>
    <!-- <span
      class="origin mr10"
      v-for="(blocs, index) in blocsList"
      :key="index + 'b'"
      v-show="(productObj.blocTagBlocId).indexOf(blocs.id) > -1"
      :class="blocs.id === 'jyy' ? 'xh' : 'hf'"
    >供货{{blocs.name}}</span> -->
    <span class="origin xh" v-if="productObj.blocTagBlocId.indexOf(adminid.id) > -1">供货{{ adminid.name }}</span>
    <span class="origin ml10 hf" v-if="productObj.blocTagBlocId.indexOf(jyy.id) > -1">供货{{ jyy.name }}</span>
    <!-- <span class="ml10 origin xh">供货精英园</span> -->
    <span class="origin" v-if="!productObj.blocTagBlocId"></span>
  </div>
</template>
<script>
import global from 'global'
import { getBlocs } from '@/serve/open'
export default {
  name: 'productBox',
  props: {
    productObj: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      blocsList: [], // 联盟列表
      adminid: {},
      jyy: {},
      priFlag: false
    }
  },
  methods: {
    goDetail () {
      this.$emit('goDetail')
    },
    // 获取图片
    getPhoto (pics) {
      if (pics.indexOf(',') > -1) {
        let temp = pics.split(',')
        return global.file.url + '/sys/fs/' + temp[0] + '?s=5'
      } else {
        return global.file.url + '/sys/fs/' + pics + '?s=5'
      }
    }
  },
  created () {
    if (
      this.productObj.ageStage.includes('PS') ||
      this.productObj.ageStage.includes('JS') ||
      this.productObj.ageStage.includes('HS')
    ) {
      // this.priFlag = true
      this.$set(this.productObj, 'priFlag', true)
    }
    getBlocs().then(res => {
      // this.blocsList = res
      res.forEach(item => {
        if (item.id === 'adminid') {
          this.adminid = item
        } else if (item.id === 'jyy') {
          this.jyy = item
        }
      })
    })
  }
}
</script>
<style lang="less" scoped>
.product-box {
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 4px;
  height: 305px;
  width: 215px;
  cursor: pointer;
  display: inline-block;
  margin-left: 15px;
  position: relative;
  &:hover {
    box-shadow: 0 2px 5px #ccc;
  }
  &:hover > .top-img > img {
    width: 105%;
  }
  .logoSchool {
    position: absolute;
    top: 3px;
    left: 3px;
    .hf-img:nth-child(2) {
      left: 56px;
    }
  }
  .top-img {
    height: 205px;
    width: 100%;
    overflow: hidden;
    img {
      transition: all 0.3s;
    }
  }
  .title {
    font-size: 14px;
    width: 200px;
    margin: 5px 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .price {
    margin: 5px 0;
    .new-price {
      font-size: 18px;
      color: #e84a4a;
    }
    .old-price {
      color: #ccc;
      text-decoration-line: line-through;
    }
  }
  .origin {
    padding: 3px 6px;
    border-radius: 4px;
    font-size: 12px;
    color: #fff;
  }
  .xh {
    background: #7ccb9b;
  }
  .hf {
    background: skyblue;
  }
}
</style>
